import { createContext, useContext, useState, ReactNode, Dispatch, SetStateAction } from "react";
import { SUPPORTED_LOCALES, type Locale } from "@/lib/i18n";

type Setter = Dispatch<SetStateAction<Locale[] | null>>;

const ValueContext = createContext<Locale[] | null>(null);
const SetterContext = createContext<Setter>(() => {});

/**
 * Çoğu sayfa tüm 7 dilde gerçekten mevcuttur (statik + hizmet sayfaları).
 * Blog yazısı gibi bazı sayfalarda sadece bir kısım dilde gerçek çeviri var —
 * bu sayfalar mount olduklarında `useSetPageLocales` ile kendi gerçek dil
 * listelerini bildirir, Header'daki dil değiştirici de sadece o dilleri gösterir.
 * Bildirim yapmayan sayfalar için varsayılan `null` = tüm diller (kısıtlama yok).
 */
export function PageLocalesProvider({ children }: { children: ReactNode }) {
  const [available, setAvailable] = useState<Locale[] | null>(null);
  return (
    <SetterContext.Provider value={setAvailable}>
      <ValueContext.Provider value={available}>{children}</ValueContext.Provider>
    </SetterContext.Provider>
  );
}

/** Header'ın dil değiştiricisinde gösterilecek liste. */
export function usePageLocales(): Locale[] {
  const available = useContext(ValueContext);
  return available ?? SUPPORTED_LOCALES;
}

export function useSetPageLocales(): Setter {
  return useContext(SetterContext);
}
